<template>
  <div style="text-align: center; padding: 1em">
    <router-link :to="item.image" style="display: flex; justify-content: center">
      <div class="beer" style="width:100%">
        <span class="beer-name" style="flex: none; font-size: 1.8rem">{{
          item.name.replaceAll("[Experimentální]", "")
        }}</span>
        <div class="position-relative">
          <img
            :src="'assets/img/beers/' + item.image + (item.image.includes('.') ? '' : '.svg')"
            style="
              flex: none;
              margin-top: 0rem;
              max-height: 300px;
              min-height: 150px;
              height: 100%;
              margin-bottom: 1rem;
            "
          />
          <font-awesome-icon icon="search" style="top: 0.5rem; right: 2rem; position: absolute"></font-awesome-icon>
        </div>
      </div>
    </router-link>
    <ItemFunctions :item="item" />
  </div>
</template>

<script>
import ItemFunctions from "./ItemFuncitons";

export default {
  name: "Item",
  props: ["item"],
  components: {
    ItemFunctions,
  },
};
</script>
<style>
.experimental .beer img {
  border-radius: 10px;
  box-shadow: 0px 0px 0px 2px #ffffff52;
}
</style>
